// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_ZOm","cls2":"ProfileDropdown-cls2_V9S ProfileDropdown-cls1_ZOm"};